import { render, staticRenderFns } from "./FeesView.vue?vue&type=template&id=64166c14"
import script from "./FeesView.vue?vue&type=script&lang=js"
export * from "./FeesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports